// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"b601d395","453":"d1e5ef97"}[chunkId] + ".chunk.js";
};